import React, { Component } from 'react'
import { Button,Modal, ModalHeader, ModalBody, ModalFooter,Form,FormGroup,Label,Table } from 'reactstrap';
import DropDown from 'shared/components/DropDown/index';
import Input from 'shared/components/Input/index';
import ActionButton from 'shared/components/ActionButton/index';
import TextArea from 'shared/components/Input/text_area';
import * as FontAwesome from 'react-icons/lib/fa';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import default_image from '../../../web/public/images/default.png';


export default class PeriodicalModel extends Component {

  constructor() {
    super()
    this.cellActionButton = this.cellActionButton.bind(this);
    this.cellType=this.cellType.bind(this);
    this.cellTyperequired=this.cellTyperequired.bind(this);
   }

  cellActionButton(cell, row, enumObject, rowIndex) {
    let theButton;
      theButton = <div><ActionButton color={"danger"} value={row.field_id} size={"sm"} button_name={<FontAwesome.FaTrash/>} button_click={() => this.props.delete_report_click(row.field_id)} className="sub-header-button-right"/></div>
      return theButton;
  }

  cellType(cell, row, enumObject, rowIndex){
    let label;
    this.props.reporting_type.map(x=>{
      if(x.id==row.data_type_id)
      {
        label=<span key={x.id}>{x.name}</span>
      }
    })
    return label;
  }

  cellTyperequired(cell, row, enumObject, rowIndex){
    let label;
    if(row.is_mandatory==0){
      label=<span>Not Required</span>
    }
    else
    {
      label=<span>Required</span>
    }
    
    return label;
  }


  render() {
    return (
        <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className="modal-lg">
        <ModalHeader toggle={this.props.toggle}>Add/Edit Periodical</ModalHeader>
        
        <ModalBody>
        {this.props.periodical_data.map(x=>
            <div key={x.id}>
              <div className="row">
                <div className="col-md-12">
                  <FormGroup>
                    <Label>Name</Label>
                    <Input type={"text"} onBlur={this.props.onBlur} id={"name-" + x.id} name={"name"} placeholder={""} onChange={this.props.onChange} value={x.name} maxLength={50} />
                    <span className="error-text">{this.props.validator.message('name', x.name, 'required', false, { default: 'This field is required.' })}</span>
                     {this.props.check_exist_message!=false?<span className="error-text">Record already exist.</span>:''}
                  </FormGroup>
                </div>
              </div>

               <Label>Icon</Label>
              <div className="row">
                    <div className="col-md-3 text-center">{x.icon_hash!==undefined?<img src={"data:image/png;base64,"+x.icon_hash} alt="" style={{height:"40px",width:"40px",borderRadius:"50%"}}/>:<img src={x.icon!=""?x.icon:default_image} alt="" style={{height:"40px",width:"40px",borderRadius:"50%"}}/>}</div>
                    <div className="col-md-9"><FormGroup><Input type={"file"} accept={"image/x-png,image/jpeg"} id={"icon-" + x.id} value={this.props.image_name} name={"icon"} onChange={this.props.onImageChange} /></FormGroup></div>
              </div>

              <div className="row">

                <div className="col-md-12">
                  <FormGroup>
                    <Label>Description</Label>
                    <TextArea value={x.description} id={"description-" + x.id} name={"description"} onChange={this.props.onChange} maxLength={200} placeholder={""} />
                    <span className="error-text">{this.props.validator.message('description', x.description, 'required', false, { default: 'This field is required.' })}</span>
                  </FormGroup>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <FormGroup>
                    <Label>Default Frequency</Label>
                    <DropDown name={"default_frequency_type_id"} id={"default_frequency_type_id-" + x.id} onChange={this.props.onChange} data={this.props.frequency_data} value={x.default_frequency_type_id} first_element={"--Select frequency--"} />
                    <span className="error-text">{this.props.validator.message('default_frequency_type_id', x.default_frequency_type_id, 'required|gt:0', false, { default: 'This field is required.' })}</span>
                  </FormGroup>
                </div>
                <div className="col-md-6">
                  <FormGroup>
                    <Label>Default Occurrences Count In Frequency</Label><br/>
                    <span>{x.default_frequency_count}</span>
                     {/* <Input type={"text"} name={"default_frequency_count"} readOnly={true} id={"default_frequency_count-" + x.id} value={x.default_frequency_count} placeholder={""} /> */}
                     {/*<span className="error-text">{this.props.validator.message('default_frequency_count', x.default_frequency_count, 'required|gt:0', false, { default: 'This field is required.' })}</span> */}
                  </FormGroup>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <FormGroup>
                    <Label>Allocation Preference</Label>
                    <DropDown name={"allocation_preference_id"} id={"allocation_preference_id-" + x.id} onChange={this.props.onChange} data={this.props.preferance_data} value={x.allocation_preference_id} first_element={"--Select preference type--"} />
                    <span className="error-text">{this.props.validator.message('allocation_preference_id', x.allocation_preference_id, 'required|gt:0', false, { default: 'This field is required.' })}</span>
                  </FormGroup>
                </div>
                <div className="col-md-6">
                  <FormGroup>
                    <Label>Status</Label>
                    <DropDown name={"status"} id={"status-" + x.id} disabled= {x.contract_count>0?true:false} data={this.props.status_data} onChange={this.props.onChange} value={x.status} first_element={"--Select status--"} />
                    <span className="error-text">{this.props.validator.message('status', x.status, 'required|gt:0', false, { default: 'This field is required.' })}</span>
                  </FormGroup>
                </div>
              </div>


              <FormGroup>
                <div className="form-check"><label className="form-check-label "><input type="checkbox" className="form-check-input" id={"is_default_seperately_charge-" + x.id} value={x.is_default_seperately_charge} checked={x.is_default_seperately_charge} onChange={this.props.oncheck} /> Is separately charged</label></div>
              </FormGroup>

              {this.props.charged_show ?
                <div className="row saparate-charge-div">
                  <div className="col-md-6">
                    <FormGroup>
                      <Label>Charge Type</Label>
                      <DropDown name={"default_charge_type_id"} id={"default_charge_type_id-" + x.id} onChange={this.props.onChange} data={this.props.charge_data} value={x.default_charge_type_id} first_element={"--Select charge type--"} />
                      <span className="error-text">{this.props.validator.message('default_charge_type_id', x.default_charge_type_id, 'required|gt:0', false, { default: 'This field is required.' })}</span>
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                      <Label>Charge Amount</Label>
                      <Input type={"number"} min={0} name={"default_charge_amount"} id={"default_charge_amount-" + x.id} maxLength={6} onChange={this.props.onChange} value={x.default_charge_amount}  />
                      <span className="error-text">{this.props.validator.message('default_charge_amount', x.default_charge_amount, 'required|max:6|gt:0', false, { default: 'This field is required.',max:'Maximum 6 character allowed.',gt:'Charge must be greater than zero.' })}</span>
                    </FormGroup>
                  </div>
                </div>
                : null}
              <FormGroup>

                <Label>Reporting Fields</Label>
                {this.props.reporting_field.map(r =>
                  <div className="row" key={r.field_id}>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label>Label</Label>
                        <Input type={"text"} id={"label-" + r.field_id} name={"label"} maxLength={20}  value={r.label} onChange={this.props.onrChange} />
                        {/* <span className="error-text">{this.props.validator.message('label', r.label, 'required',false,{default: 'This field is required.'})}</span>  */}
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label>Type</Label>
                        <DropDown id={"data_type_id-" + r.field_id} name={"data_type_id"} value={r.data_type_id} onChange={this.props.onrChange} data={this.props.reporting_type} first_element={"--Select type--"} />
                        {/* <span className="error-text">{this.props.validator.message('data_type_id', x.data_type_id, 'required',false,{default: 'This field is required.'})}</span> */}
                      </FormGroup>
                    </div>
                    <div className="col-md-3" style={{ paddingTop: "30px" }}>
                      <FormGroup>
                        <label className="form-check-label "><input type="checkbox" className="form-check-input" name={"is_mandatory"} id={"is_mandatory-" + r.field_id} value={r.is_mandatory} checked={r.is_mandatory} onChange={this.props.onMandatoryCheck} />Mandatory </label>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <br />
                      <ActionButton color={"primary"} size={"sm"} button_name={"Save"} button_click={this.props.saveClick} className="sub-header-button-right " />
                       <ActionButton color={"danger"} size={"sm"} button_name={"Cancel"} button_click={this.props.rCancel} className="sub-header-button-right"/> 
                    </div>
                  </div>
                )}
            </FormGroup>

            <FormGroup>
              <div className="row">
              <div className="col-md-12">
                <BootstrapTable ref='table' data={ this.props.reporting_array } >
                  <TableHeaderColumn dataField='label' isKey={ true } >Label Text</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={this.cellType} >Data Type</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={this.cellTyperequired} >Is Required</TableHeaderColumn>
                  <TableHeaderColumn dataField='' dataFormat={this.cellActionButton}>Action</TableHeaderColumn>
                </BootstrapTable>
              </div>
              </div>
            </FormGroup>
           
          </div>
        )}
        </ModalBody>
       
        <ModalFooter>
          <ActionButton color={"primary"} size={"md"} button_name={"Save & Close"} button_click={this.props.onSubmitClick}/>{' '}
          <ActionButton color={"danger"} size={"md"} button_name={"Cancel"} button_click={this.props.toggle}/>
        </ModalFooter>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Models/periodical_model.js